const runsForm = {
  bindings: {
    selection: '<',
    runs: '<',
    onFormSubmit: '&',
    hasEdit: '<',
    isLocked: '<',
  },
  templateUrl:
    '/modules/pis-tool/runs/runs-form/runs-form.html',
  controller: 'RunsFormController',
};

angular
  .module('pis-tool.module')
  .component('runsForm', runsForm);
